module.exports = __webpack_public_path__ + "static/media/contact-plane.da14917a.svg";